export default function getCustomDomain(){        
    let domain = window.location.hostname
    let systemHostNames = ['.oido.me', '.web.app', 'localhost']
    for(let hostName of systemHostNames){
      if(domain.endsWith(hostName)){
        return null
      }
    }
    return domain
}